import { useLingui } from "@lingui/react/macro"
import React from "react"

import Tab from "../../../../design-system/tab"
import Tabs from "../../../../design-system/tabs"
import { ALL_CATEGORIES, CATALOG_CATEGORIES, CategoryKey } from "../types"

export interface Props {
  selectedCategory?: CategoryKey
  setSelectedCategory: (cardType: CategoryKey) => void
  disabled?: boolean
}

function CatalogTabs({
  selectedCategory = ALL_CATEGORIES,
  setSelectedCategory: setSelectedCardType,
  disabled,
}: Props) {
  const { t } = useLingui()
  const selectedIndex = CATALOG_CATEGORIES.indexOf(selectedCategory)

  const getTranslatedCategoryLabel = (label: CategoryKey) => {
    switch (label) {
      case "All categories":
        return t`All categories`
      case "Prepaid cards":
        return t`Prepaid cards`
      case "Gift cards":
        return t`Gift cards`
      case "Monetary options":
        return t`Monetary options`
      case "Charities":
        return t`Charities`
      default:
        return label // Fallback, should not happen with current types
    }
  }

  return (
    <Tabs disabled={disabled}>
      {CATALOG_CATEGORIES.map((categoryLabel, index) => (
        <Tab
          key={categoryLabel}
          index={index}
          tabIndex={selectedIndex}
          onClick={() => setSelectedCardType(categoryLabel)}
          data-testid={`catalog-tab-${categoryLabel}`}
        >
          {getTranslatedCategoryLabel(categoryLabel)}
        </Tab>
      ))}
    </Tabs>
  )
}

export default CatalogTabs
